// // Copyright Open Trade Technology Ltd. 2023. All rights reserved.

import { useOtChainState } from '@react/redux/store'
import dayjs, { Dayjs } from 'dayjs'
import React, { useState } from 'react'

import { Box, Typography } from '@mui/material'

import { DateTimePicker, LocalizationProvider } from '@mui/x-date-pickers-pro'
import { AdapterDayjs } from '@mui/x-date-pickers-pro/AdapterDayjs'

export default function ReportDateTimePicker(props: {
  onSelectedChange: (dayTime: Dayjs) => void
  forEvents: boolean
  initialDateTime?: Dayjs
}): React.ReactElement {
  const {
    chainConfiguration: { chainTimestampDelta },
  } = useOtChainState()

  const [dateTime, setDateTime] = useState<Dayjs>(
    props.initialDateTime ?? dayjs().utc().add(chainTimestampDelta, 'seconds')
  )

  const localSetDateTime = (newDateTime: Dayjs) => {
    if (newDateTime) {
      setDateTime(newDateTime)
      props.onSelectedChange(newDateTime)
    }
  }

  return (
    <Box sx={{ flexGrow: 0, width: 275, flexDirection: 'column', display: 'flex', marginBottom: 6 }}>
      <Typography sx={{ marginTop: -1, marginBottom: 1, height: 24 }} variant="caption">
        Date Range
      </Typography>
      <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="UTC">
        <DateTimePicker
          label="Date Time to start from"
          value={dateTime}
          onChange={(newValue) => {
            if (newValue) localSetDateTime(newValue)
          }}
        />
      </LocalizationProvider>
    </Box>
  )
}
